import axios from "axios";
import { t } from "i18next";
import _ from "lodash";

import AlertsService from "services/alerts-service";

import { mergeStorage, omitStorage } from "hooks/useStorage";

const QuestionnairesApi = {
    getQuestionnaires: async () => {
        try {
            const { data: response } = (await axios.get(`/questionnaires`)) as any;
            mergeStorage(`questionnaires`, _.keyBy(response, `id`));
            return response;
        } catch (error) {
            throw AlertsService.showError(t("tga113r2za"));
        }
    },
    createQuestionnaire: async (details: any) => {
        try {
            const { data: response } = (await axios.post(`/questionnaires`, { details })) as any;
            await QuestionnairesApi.getQuestionnaires();
            return response;
        } catch (error) {
            throw AlertsService.showError(t("ozlnnrwa6ts"));
        }
    },
    updateQuestionnaire: async (questionnaire: { id: string; universityId: string; [key: string]: any }) => {
        try {
            const { data: response } = (await axios.put(`/questionnaires`, questionnaire)) as any;
            await QuestionnairesApi.getQuestionnaires();
            AlertsService.showSuccess(`Изменения сохранены`);
            return response;
        } catch (error) {
            throw AlertsService.showError(t("0l4dcp01wmzr"));
        }
    },
    deleteQuestionnaire: async (questionnaireId: string) => {
        try {
            await axios.delete(`/questionnaires/${questionnaireId}`);
            omitStorage(`questionnaires.${questionnaireId}`);
            AlertsService.showSuccess(`Удаление завершено`);
            return;
        } catch (error) {
            throw AlertsService.showError(t("l9bwqdtqsq9"));
        }
    },
    getQuestionnaireInfo: async (id: string) => {
        try {
            const { data: response } = (await axios.get(`/questionnaires/${id}`)) as any;
            mergeStorage(`questionnaires.${id}`, response);
            return response;
        } catch (error) {
            throw AlertsService.showError(t("fcrh6s3f80g"));
        }
    },
};

export default QuestionnairesApi;
